import { IFileType } from "@zappar/zw-api-client";
import { ZapworksAsset } from "./base";
import { MediaType } from "../../../types";

export class Model3DAsset extends ZapworksAsset<IFileType.Model3D> {
  getMediaType() {
    return MediaType.Model3D;
  }

  async getImageUrlForCard(size?: { width: number; height?: number }, useCache = true) {
    const baseUrl = await this.getFileUrl(useCache);
    let path = 'frame0.png';
    // if (size) { // TODO: Uncomment when Zapworks supports resized thumbnails for Model3D
    //   path = `frame0.png.r.w${size.width}${size.height ? `.h${size.height}` : ''}.png`;
    // }
    return this.addPathToFileUrl(new URL(baseUrl), path).toString();
  }

  async getDownloadUrl(useCache = true) {
    const baseUrl = await this.getFileUrl(useCache);
    return this.addPathToFileUrl(new URL(baseUrl), 'model.glb').toString();
  }

  getMetadata() {
    return {
      ...super.getMetadata(),
      animations: this.file.meta.animations || [],
    };
  }
}
